import makeSettingsReducer from 'app/common/reducers/settings/makeSettingsReducer';

const defaultState = {
  changeLimitsBlockedUntil: 0,
};

export default makeSettingsReducer('limits', defaultState);
